import { Redirect } from 'react-router-dom';

const DefaultRedirect = ({ roles, routes, includesRole }) => {
  if (!roles || roles.length === 0) {
    return null; 
  }

  const defaultRoute = routes.find(el => el.path === '/');
  const defaultPath = routes.find(el => el.path === defaultRoute.pathTo);

  const isDefaultPathAvailable = includesRole(defaultPath?.roles, roles);
  
  const destination = isDefaultPathAvailable ? defaultRoute.pathTo : '/animals';

  return <Redirect to={destination} exact />;
};

export default DefaultRedirect;
